define('responsive-gameday/controllers/WrapupPanelViewController',['require','exports','module','responsive-gameday/controllers/GamePanelViewController','message-service/message-service','../views/Monitor/Events/ViewModelUpdateEvents','responsive-gameday/controllers/WrapupBoxScoreViewController','responsive-gameday/controllers/WrapupPlaysViewController','responsive-gameday/controllers/WrapupViewController','responsive-gameday/controllers/TeamMatchupSummaryViewController','Responsive/util/dom','jquery'],function(require,exports,module){
	var GamePanelViewController = require("responsive-gameday/controllers/GamePanelViewController"),
		MessageService = require("message-service/message-service"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        WrapupBoxScoreViewController = require("responsive-gameday/controllers/WrapupBoxScoreViewController"),
        WrapupPlaysViewController = require( "responsive-gameday/controllers/WrapupPlaysViewController" ),
        WrapupViewController = require('responsive-gameday/controllers/WrapupViewController'),
        TeamMatchupSummaryViewController = require('responsive-gameday/controllers/TeamMatchupSummaryViewController'),
        ReDom = require("Responsive/util/dom"),
        $ = require('jquery');


	// Add private variables here
	var Superclass;

	// Add private methods here
    function WrapupPanelViewController (){
        var wrap = new WrapupViewController(),
            box  = new WrapupBoxScoreViewController(),
            plays= new WrapupPlaysViewController(),
            header=new TeamMatchupSummaryViewController();

        wrap.canScroll = false;
        WrapupPanelViewController.superclass.constructor.call(this,{
            preload : false,
            title   : "WrapupTabs",
            nav     : 'tabs',
            canScroll: false,
            playerCards : {
                usePageUrl : true
            },
            header : header,
            views       : [
                {
                    name : 'Wrap',
                    id   : "wrap",
                    viewController  : wrap
                },{
                    name : 'Box',
                    id  : 'Box',
                    viewController  : box
                },{
                    name : 'Play-by-Play',
                    id  : "Play-by-Play",
                    viewController  : plays
                }                    
                
            ]
        });

    }
    GamePanelViewController.spawn(WrapupPanelViewController).define({
		viewWillAppear: function () {
			var that = this;

			this.onBeat = function(data){
				var activeTab = that.slots[that.focus];
				//NOPE, go to the box
				if(!data || data && !data.videoList) {
    				that.setWrapTabClickable(false);
					if((activeTab.id||"").toLowerCase()=="wrap"){
						that.setTabView("box");
					}
				}else {
					that.setWrapTabClickable(true);
				}
			}

			MessageService.addListener.call(that, VMEvents.UPDATE_WRAPUP, that.onBeat);
			Superclass.viewWillAppear.call(this);
		},
		viewDidAppear: function() {
			var that = this;
			Superclass.viewDidAppear.call(this);
			MessageService.publish(VMEvents.REQUEST_WRAPUP_DATA);
		},

		viewWillDisappear: function(){
			MessageService.removeListener(VMEvents.UPDATE_WRAPUP, this.onBeat);
			Superclass.viewWillDisappear.call(this);			
		},

		setWrapTabClickable : function(enable) {
			var wrapTab = this.slotsById.wrap;
			if(!enable) {
	        	ReDom.setClassName(wrapTab.nav, 'disabled');
	        } else {
	        	ReDom.removeClassName(wrapTab.nav, 'disabled');
	        }
		}

    });

	Superclass = WrapupPanelViewController.superclass;
	return WrapupPanelViewController;
});
